<template>
    <div class="estates-list-menu" v-if="lang && lang.labels">
       <div class="container">
            <div class="row max-500">
                <div class="col-auto pr-0">
                    <button class="btn whitecta" @click="toggleListingView">
                        <masked-image :src="'/img/icons/' + $root.network + '/maps.svg'"></masked-image> {{ showMap ? lang.labels.list : lang.labels.map }}
                    </button>
                </div>

                <div class="col">
                    <button class="btn btn-network" @click="openSaveSearchModal">
                        <!-- <masked-image :src="'/img/icons/notifications.svg'"></masked-image> -->
                        <span>{{ lang.labels.save_search }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showMap: false,
        }
    },

    props: {
        search: {
            type: Object,
            required: false,
        },

        title: {
            type: String,
            required: true,  
        },
    },

    components: {
    },

    computed: {
        lang() {
            //return this.$root.lang.bottom_menu.estates_list_menu
            return this.$root.lang.bottom_menu ? this.$root.lang.bottom_menu.estates_list_menu : []
        },
    },

    methods: {
        openSaveSearchModal() {
            if (this.$root.country == 'it' && !this.is_logged_in()) {
                window.events.$on('login_completed', () => {
                    this.openSaveSearchModal()
                })

                window.events.$emit('showModal', { name: 'login', data: { action: true }})
            } else {
                window.events.$emit('showModal', { name: 'save_search' })
            }
        },

        toggleListingView() {
            this.showMap = !this.showMap;
            window.events.$emit('toggleListingView', { map: this.showMap, list: !this.showMap })
        },
    },
}
</script>